<template>
  <div class="big">
    <div class="page_title">医生奖励活动记录</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>活动名称</span>
            <el-input
              placeholder="请输入"
              v-model="act_name"
              style="width: 110px; margin-left: 6px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 110px; margin-left: 6px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医生手机</span>
            <el-input
              placeholder="请输入"
              v-model="phone"
              style="width: 110px; margin-left: 6px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>领奖提交时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              style="width: 225px; margin-left: 6px"
              @change="search"
              clearable
            ></el-date-picker>
            <el-button
              type="info"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 6px;
              "
              size="medium"
              @click="search"
            >查询</el-button>
            <el-button
              type="primary"
              @click="excelexport"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('748') : false
              "
              size="medium"
            >导出</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="活动名称"
              prop="act_name"
            ></el-table-column>
            <el-table-column
              label="医生姓名"
              prop="doctor_name"
            >
            </el-table-column>
            <el-table-column
              label="手机号"
              prop="phone"
            ></el-table-column>
            <el-table-column
              label="活动开始时间"
              prop="start_time"
            ></el-table-column>
            <el-table-column
              label="活动结束时间"
              prop="end_time"
            ></el-table-column>
            <el-table-column
              label="医生成绩"
              prop="total_money"
            ></el-table-column>
            <el-table-column
              label="奖励等级"
              prop="level"
            ></el-table-column>
            <el-table-column
              label="奖品名称"
              prop="prize_name"
            ></el-table-column>
            <el-table-column
              label="领奖提交时间"
              prop="create_time"
            ></el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin:20px 0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      date: [],
      doctor_name: '',
      phone: '',
      act_name: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        act_name: this.act_name
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.create_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/doctor/getDoctorActivityLog', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.start_time = dayjs
                .unix(item.start_time)
                .format('YYYY-MM-DD HH:mm');
              item.end_time = dayjs
                .unix(item.end_time)
                .format('YYYY-MM-DD HH:mm');
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm');
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },

    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //导出数据
    excelexport() {
      let data = {
        doctor_name: this.doctor_name,
        phone: this.phone,
        act_name: this.act_name
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format('YYYY-MM-DD');
        data.create_time_end = dayjs(this.date[1]).format('YYYY-MM-DD');
      }
      this.axios
        .post('platform/doctor/exportDoctorActivityLog', data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              '//' +
              window.location.host +
              res.data.url;
            location.href = host;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 14px;
  }
}
</style>
